(() => {
  const SELECTOR = '[data-inknfiber-best-sellers-slider]';
  const FRAME_DELAY = 5000;
  const RESUME_DELAY = 1400;

  function initSlider(track) {
    if (!track || track.dataset.inknfiberBestSellersInitialized === 'true') return;

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) return;

    track.dataset.inknfiberBestSellersInitialized = 'true';

    let intervalId = 0;
    let resumeTimeout = 0;
    let paused = false;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function cardStep() {
      const firstCard = track.querySelector('.inknfiber-product-tile');
      if (!firstCard) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function goToNextFrame() {
      if (paused || document.hidden) return;

      const maxLeft = maxScroll();
      if (maxLeft <= 4) return;

      const step = cardStep();
      const nextLeft = track.scrollLeft + step;
      const isAtEnd = track.scrollLeft >= maxLeft - 2;
      const targetLeft = isAtEnd ? 0 : Math.min(nextLeft, maxLeft);

      track.scrollTo({
        left: targetLeft,
        behavior: 'smooth',
      });
    }

    function stop() {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = 0;
      }
    }

    function start() {
      stop();
      if (motionQuery.matches) return;
      intervalId = window.setInterval(goToNextFrame, FRAME_DELAY);
    }

    function resumeSoon() {
      window.clearTimeout(resumeTimeout);
      resumeTimeout = window.setTimeout(() => {
        paused = false;
      }, RESUME_DELAY);
    }

    track.addEventListener('pointerenter', () => {
      paused = true;
    });

    track.addEventListener('pointerleave', () => {
      paused = false;
    });

    track.addEventListener('focusin', () => {
      paused = true;
    });

    track.addEventListener('focusout', () => {
      paused = false;
    });

    track.addEventListener('pointerdown', () => {
      paused = true;
      window.clearTimeout(resumeTimeout);
    });

    track.addEventListener('pointerup', resumeSoon);
    track.addEventListener('pointercancel', resumeSoon);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    const handleMotionChange = (event) => {
      if (event.matches) {
        stop();
      } else {
        start();
      }
    };

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', handleMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(handleMotionChange);
    }

    start();
  }

  function init(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
